/**
 * Con qué lista de precios sale una cuenta: en el cobro de la mesa y en su
 * precuenta. Se ve SIEMPRE cuál está puesta, incluso «Normal».
 *
 * ⚠️ Y SE VE AUNQUE NO HAYA LISTAS (2026-11-04). Se escondía, y el dueño, probando
 * en un negocio sin listas, concluyó que el selector no existía: «debería poderse
 * seleccionar el precio». Sin listas lo honrado es decirlo y decir dónde se crean.
 */

import { Link } from "react-router-dom";
import { cx } from "@/components/ui";
import { useAuth } from "@/stores/auth";

export function ElegirListaDePrecios({
  listas,
  elegida,
  alElegir,
}: {
  /** Sin definir = todavía se están consultando: no se afirma que no haya. */
  listas: { id: string; nombre: string }[] | undefined;
  elegida: string | null;
  alElegir: (id: string | null) => void;
}) {
  const puede = useAuth((s) => s.puede);

  if (listas === undefined) return null;
  // Quien no puede crearlas no tiene nada que hacer con el aviso.
  if (listas.length === 0 && !puede("catalog.precios")) return null;

  return (
    <div className="rounded-[var(--radius-control)] border border-line bg-surface px-3 py-2.5">
      <p className="text-sm font-medium text-ink">Lista de precios</p>
      <div className="mt-1.5 flex flex-wrap gap-1.5">
        {[{ id: null, nombre: "Normal" }, ...listas].map((l) => (
          <button
            key={l.id ?? "normal"}
            type="button"
            aria-pressed={elegida === l.id}
            onClick={() => alElegir(l.id)}
            className={cx(
              "rounded-full border px-3 py-1 text-xs font-medium transition",
              elegida === l.id
                ? "border-accent bg-accent text-on-accent"
                : "border-line text-muted hover:border-accent hover:text-ink",
            )}
          >
            {l.nombre}
          </button>
        ))}
      </div>
      {elegida && (
        <p className="mt-1.5 text-xs text-muted">
          Los productos sin precio en esta lista conservan el precio de la cuenta.
        </p>
      )}
      {listas.length === 0 && (
        <p className="mt-1.5 text-xs text-muted">
          Este negocio aún no tiene otras listas de precios.
          {puede("catalog.precios") && (
            <>
              {" "}
              <Link
                to="/ajustes/listas-de-precios"
                className="font-medium text-accent hover:underline"
              >
                Crear una lista
              </Link>
            </>
          )}
        </p>
      )}
    </div>
  );
}
